import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import CommissionsWalletCardListItem from './CommissionsWalletCardListItem';
import WalletProp from '../../proptype/walletProp';

export default function CommissionsWalletCardList(props) {
  const {
    wallets,
    activeWalletIndex,
    onSelectWallet,
    onSeeTransactions,
    onWithdrawal,
    onExchange,
  } = props;

  const scrollRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const updateArrows = useCallback(() => {
    const el = scrollRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 5);
    setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 5);
  }, []);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    updateArrows();
    el.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    return () => {
      el.removeEventListener('scroll', updateArrows);
      window.removeEventListener('resize', updateArrows);
    };
  }, [wallets, updateArrows]);

  const scroll = useCallback(direction => {
    if (!scrollRef.current) return;
    const container = scrollRef.current;
    const card = container.querySelector('.wallet-credit-card');
    if (!card) return;
    const scrollAmount =
      card.offsetWidth + parseFloat(getComputedStyle(container).gap || 20);
    container.scrollBy({
      left: direction === 'next' ? scrollAmount : -scrollAmount,
      behavior: 'smooth',
    });
  }, []);

  return (
    <div className="commissions-wallet-picker-carousel">
      <button
        type="button"
        className={`commissions-wallet-picker-arrow commissions-wallet-picker-arrow--prev${
          canScrollLeft ? '' : ' commissions-wallet-picker-arrow--hidden'
        }`}
        onClick={() => scroll('prev')}
        aria-label="Previous wallets"
        aria-hidden={!canScrollLeft}
        tabIndex={canScrollLeft ? 0 : -1}
      >
        <i className="la la-angle-left" />
      </button>
      <div className="commissions-wallet-picker-cards-grid" ref={scrollRef}>
        {wallets.map((wallet, index) => (
          <CommissionsWalletCardListItem
            key={`${wallet.type}-${wallet.currency || index}`}
            wallet={wallet}
            isActive={index === activeWalletIndex}
            onSelect={() => onSelectWallet(index)}
            onSeeTransactions={onSeeTransactions}
            onWithdrawal={onWithdrawal}
            onExchange={onExchange}
          />
        ))}
      </div>
      <button
        type="button"
        className={`commissions-wallet-picker-arrow commissions-wallet-picker-arrow--next${
          canScrollRight ? '' : ' commissions-wallet-picker-arrow--hidden'
        }`}
        onClick={() => scroll('next')}
        aria-label="Next wallets"
        aria-hidden={!canScrollRight}
        tabIndex={canScrollRight ? 0 : -1}
      >
        <i className="la la-angle-right" />
      </button>
    </div>
  );
}

CommissionsWalletCardList.propTypes = {
  wallets: PropTypes.arrayOf(PropTypes.shape(WalletProp.propType).isRequired)
    .isRequired,
  activeWalletIndex: PropTypes.number.isRequired,
  onSelectWallet: PropTypes.func.isRequired,
  onSeeTransactions: PropTypes.func.isRequired,
  onWithdrawal: PropTypes.func.isRequired,
  onExchange: PropTypes.func.isRequired,
};
